import Header from './components/Header';
import Footer from './components/Footer';

import Top from './pages/Top';
import About from './pages/About';
import Error from './pages/Error';

import { BrowserRouter, Switch, Route } from 'react-router-dom';

import {
  createMuiTheme,
  responsiveFontSizes,
  ThemeProvider,
} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

const theme = responsiveFontSizes(
  createMuiTheme({
    palette: {
      // type: 'dark',
      primary: {
        main: '#fafafa',
      },
      secondary: {
        main: '#616161',
      },
    },
    typography: {
      fontSize: 16,
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
    spacing: (factor) => `${0.25 * factor}rem`,
  })
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <BrowserRouter>
        <Header />

        <Container maxWidth="lg">
          <Switch>
            <Route path="/" exact children={<Top />} />
            <Route path="/about" exact children={<About />} />
            <Route children={<Error />} />
          </Switch>
        </Container>
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
